import { withInstall } from '@lit-element/utils'

import Split from './src/split.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtSplit: SFCWithInstall<typeof Split> = withInstall(Split)
export default LtSplit

export * from './src/split'
